import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class TopBar extends PureComponent {
  render() {
    const { logoUrl, email } = this.props;

    const exit = (
      <a style={{ marginLeft: '5px' }} className="ph-primary" href="/logout">
        Sair
      </a>
    );

    return (
      <div className="app-header header-shadow ph-top-color">
        <div className="app-header__logo">
          <div>
            <a href="/">
              <img src={logoUrl} alt="Logo" style={{ height: '60px', padding: '5px' }} />
            </a>
          </div>
        </div>
        <div className="app-header__content" />
        <span style={{ marginRight: '20px' }}>
          {email && (`Olá, ${email}`)}
          {email && exit}
        </span>
        <div className="powered-by-inteligov badge badge-pill badge-dark">
          <a href="http://inteligov.com.br" rel="noreferrer" target="_blank">
            Powered by
            <img
              src="https://s3.amazonaws.com/www.zenlobby.com.assets/brands/inteligov_white.svg"
              alt="Inteligov"
            />
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  logoUrl: store.configState.logoUrl,
});

TopBar.propTypes = {
  logoUrl: PropTypes.string,
  email: PropTypes.string,
};

TopBar.defaultProps = {
  logoUrl: '',
  email: '',
};

const ConnectHeader = connect(mapStateToProps)(TopBar);

export default ConnectHeader;
